module.exports = __webpack_public_path__ + "cx.svg?4b68133b0c177539dba65b0dac738fcc";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/cx.svg
// module id = 787
// module chunks = 27